// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NhHZfirM6XFyNIhSq1PM{position:relative;height:100%}.NhHZfirM6XFyNIhSq1PM.QlAqaTex_2Z_JHstH7Ic{position:absolute;z-index:var(--zIndex-BASE_12)}`, "",{"version":3,"sources":["webpack://./src/pages/conversations/ui/ConversationMenu/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA,CACA,WAAA,CAEA,2CACE,iBAAA,CACA,6BAAA","sourcesContent":[".wrap {\n  position: relative;\n  height: 100%;\n\n  &.mobileView {\n    position: absolute;\n    z-index: var(--zIndex-BASE_12);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `NhHZfirM6XFyNIhSq1PM`,
	"mobileView": `QlAqaTex_2Z_JHstH7Ic`
};
export default ___CSS_LOADER_EXPORT___;
